import * as React from "react"
import { cn } from "@/lib/utils/cn"

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "flat"
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = "default", ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-lg text-ink",
        {
          "bg-surface-card border border-hairline": variant === "default",
          "bg-surface-soft": variant === "flat",
        },
        className
      )}
      {...props}
    />
  )
)
Card.displayName = "Card"

export { Card }
